import React from "react";
import { Link } from "react-router-dom";

const LINKS = [
  { label: "Privacy Policy", path: "/privacy", testid: "footer-privacy-link" },
  { label: "Terms of Service", path: "/terms", testid: "footer-terms-link" },
  { label: "Cookie Policy", path: "/cookies", testid: "footer-cookies-link" },
  { label: "Data Deletion", path: "/data-deletion", testid: "footer-data-deletion-link" },
];

export default function Footer() {
  return (
    <footer
      data-testid="app-footer"
      className="mt-12 border-t border-[#242B30] pt-6 pb-2"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2.5 min-w-0">
          <img src="/karyow-logo.png" alt="KARYOW" className="h-7 w-7 rounded-lg object-cover shrink-0" />
          <span className="text-xs text-zinc-500 font-mono truncate">
            © {new Date().getFullYear()} KARYOW AI Ads Manager · karyowads.com
          </span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {LINKS.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              data-testid={l.testid}
              className="text-xs text-zinc-400 hover:text-lime-400 transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
